export const money = (n, digits = 2) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;

export const num = (n, digits = 0) =>
  Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });

export function computeTotals(boq) {
  const sections = boq?.sections || [];
  let base = 0;
  let labor = 0, material = 0, equipment = 0;
  const sectionTotals = sections.map((sec) => {
    let s = 0;
    (sec.items || []).forEach((it) => {
      const qty = +it.quantity || 0;
      labor += qty * (+it.labor_rate || 0);
      material += qty * (+it.material_rate || 0);
      equipment += qty * (+it.equipment_rate || 0);
      const rate = (+it.labor_rate || 0) + (+it.material_rate || 0) + (+it.equipment_rate || 0);
      s += qty * rate;
    });
    base += s;
    return { code: sec.code, title: sec.title, subtotal: s };
  });
  const m = boq?.markups || {};
  const overhead = (base * (+m.overhead || 0)) / 100;
  const profit = ((base + overhead) * (+m.profit || 0)) / 100;
  const contingency = (base * (+m.contingency || 0)) / 100;
  const preTax = base + overhead + profit + contingency;
  const tax = (preTax * (+m.tax || 0)) / 100;
  return {
    base_subtotal: base,
    labor_total: labor,
    material_total: material,
    equipment_total: equipment,
    overhead_amount: overhead,
    profit_amount: profit,
    contingency_amount: contingency,
    pre_tax_total: preTax,
    tax_amount: tax,
    grand_total: preTax + tax,
    section_totals: sectionTotals,
  };
}

export const lineTotal = (it) =>
  (+it.quantity || 0) * ((+it.labor_rate || 0) + (+it.material_rate || 0) + (+it.equipment_rate || 0));

export const STATUS_META = {
  draft: { label: "Draft", cls: "bg-slate-500/15 text-slate-400 border-slate-500/30" },
  tender: { label: "Tender", cls: "bg-sky-500/15 text-sky-400 border-sky-500/30" },
  review: { label: "In Review", cls: "bg-amber-500/15 text-amber-400 border-amber-500/30" },
  approved: { label: "Approved", cls: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30" },
};
